import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  /** @ignore */
  className?: string;
  /** @ignore */
  children?: React.ReactNode;
  /** Item weight. Defaults to 6 (the entire row). */
  weight?: number;
}

const GridItemBase = (props: IProps) => 
  <div className={props.className}>{props.children}</div>

const GridItem = styled(GridItemBase)`
  grid-column-start: span ${p => p.weight ?? 6};
  display: flex;
  flex-direction: column;
`

export { GridItem }
